import React from "react";
import Header from "../../components/ui/Header";
import SidebarComponents from "../../components/ui/SidebarComponents";

import DetailPaymentDashboard from "../../components/screen/dashboard/DetailPaymentDashboard";
import { SIDEBAR_WIDTH } from "../../components/constants/constant";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../components/constants/muiTheme";
import PageTemplate from "../../components/common/particles.jsx/PageTemplate";

const DetailPaymentDashboardPage = () => {
  return (
    <div className="">
      <PageTemplate
        header=""
        mainComponent={
          <ThemeProvider theme={theme}>
            <div className="text-[12px]">
              <DetailPaymentDashboard />
            </div>
          </ThemeProvider>
        }
        checkOwner={true}
      />
    </div>
  );
};

export default DetailPaymentDashboardPage;
